<template>
  <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="130" inline>
    <FormItem label="采集的URL" prop="rule_url">
      <Input v-model="formValidate.rule_url" placeholder="https://" style="width: auto" />
    </FormItem>

    <FormItem label="采集的页面数量" prop="rule_pagenumber">
      <Input v-model="formValidate.rule_pagenumber" placeholder style="width: auto" />
    </FormItem>
    <!-- <FormItem label="图片采集规则"
              prop="rule_img">
      <Input v-model="formValidate.rule_img"
             placeholder="" />
    </FormItem>-->
    <FormItem label="标题采集规则" prop="rule_title">
      <Input v-model="formValidate.rule_title" placeholder />
    </FormItem>
    <FormItem label="LINK采集规则" prop="rule_link">
      <Input v-model="formValidate.rule_link" placeholder />
    </FormItem>
    <FormItem label="时间采集规则" prop="rule_time">
      <Input v-model="formValidate.rule_time" placeholder />
    </FormItem>
    <FormItem label="手机号采集规则" prop="rule_phone">
      <Input v-model="formValidate.rule_phone" placeholder />
    </FormItem>
    <!-- <FormItem label="价格采集规则"
              prop="rule_price">
      <Input v-model="formValidate.rule_price"
             placeholder="" />
    </FormItem>-->
    <!-- <FormItem label="采集的内容类型"
              prop="rule_type">
      <Input v-model="formValidate.rule_type"
             placeholder="" />
    </FormItem>-->
    <FormItem label="采集范围切片" prop="rule_range">
      <Input v-model="formValidate.rule_range" placeholder />
    </FormItem>
    <FormItem label="来源ID" prop="source_id">
      <Input v-model="formValidate.source_id" placeholder />
    </FormItem>
    <FormItem label="区域规则" prop="rule_area">
      <Input v-model="formValidate.rule_area" placeholder />
    </FormItem>

    <!-- <FormItem label="面积规则"
              prop="source_id">
      <Input v-model="formValidate.rule_mianji"
             placeholder="" />
    </FormItem>-->
    <FormItem label="58密文" prop="source_cookie">
      <Input v-model="formValidate.source_cookie" placeholder />
    </FormItem>

    <FormItem>
      <Button type="primary" @click="handleSubmit('formValidate')">保存采集参数</Button>
      <!-- <Button @click="fullUpdate()"
      style="margin-left: 8px">全量更新数据</Button>-->
    </FormItem>
  </Form>
</template>
<script>
export default {
  name: 'ruleconfig1',
  data () {
    return {
      formValidate: {},
      ruleValidate: {
        rule_url: [
          {
            required: true,

            message: 'The name cannot be empty',
            trigger: 'blur'
          }
        ],
        rule_pagenumber: [
          {
            required: true,
            type: 'string',
            message: 'The name cannot be empty',
            trigger: 'blur'
          }
        ],
        rule_img: [
          {
            required: false,
            type: 'string',
            message: 'The name cannot be empty',
            trigger: 'blur'
          }
        ],
        rule_title: [
          {
            required: true,
            type: 'string',
            message: 'The name cannot be empty',
            trigger: 'blur'
          }
        ],
        rule_link: [
          {
            required: true,
            type: 'string',
            message: 'The name cannot be empty',
            trigger: 'blur'
          }
        ],
        rule_time: [
          {
            required: true,
            type: 'string',
            message: 'The name cannot be empty',
            trigger: 'blur'
          }
        ],
        rule_phone: [
          {
            required: true,
            type: 'string',
            message: 'The name cannot be empty',
            trigger: 'blur'
          }
        ],
        rule_price: [
          {
            required: false,
            type: 'string',
            message: 'The name cannot be empty',
            trigger: 'blur'
          }
        ],
        rule_type: [
          {
            required: false,
            type: 'string',
            message: 'The name cannot be empty',
            trigger: 'blur'
          }
        ],
        rule_range: [
          {
            required: true,
            type: 'string',
            message: 'The name cannot be empty',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  created () {
    this.getRules();
  },
  computed: {
    formData () {
      let data = {
        id: 5,
        source_id: this.formValidate.source_id,
        source_cookie: this.formValidate.source_cookie,
        rule_url: this.formValidate.rule_url,
        rule_pagenumber: Number(this.formValidate.rule_pagenumber),

        rule_title: this.formValidate.rule_title.split(','),
        rule_link: this.formValidate.rule_link.split(','),
        rule_time: this.formValidate.rule_time.split(','),
        rule_phone: this.formValidate.rule_phone.split(','),
        rule_area: this.formValidate.rule_area.split(','),

        rule_range: this.formValidate.rule_range
      };
      return data;
    }
  },
  methods: {
    handleSubmit (name) {
      console.log(this.formData);
      let _this = this;
      this.$refs[name].validate(valid => {
        if (valid) {
          this.$axios
            .request({
              url: 'caiji/?s=setting.editcaijirule',
              data: _this.formData,

              method: 'POST'
            })
            .then(json => {
              console.log(json);
            });
          this.$Message.success('Success!');
        } else {
          this.$Message.error('Fail!');
        }
      });
    },
    getRules () {
      this.$axios
        .request({
          url: 'caiji/?s=setting.getCaijiRule&source_id=1',
          method: 'GET'
        })
        .then(json => {
          let data = json.data.data;
          // console.log(data);
          let datas = {
            id: data.id,
            source_id: data.source_id,
            source_cookie: data.source_cookie,
            rule_url: data.rule_url,
            rule_pagenumber: data.rule_pagenumber,
            // rule_img: JSON.parse(data.rule_img).join(),
            rule_title: JSON.parse(data.rule_title).join(),
            rule_link: JSON.parse(data.rule_link).join(),
            rule_time: JSON.parse(data.rule_time).join(),
            rule_phone: JSON.parse(data.rule_phone).join(),
            // rule_price: JSON.parse(data.rule_price).join(),
            // rule_type: JSON.parse(data.rule_type).join(),
            rule_area: JSON.parse(data.rule_area).join(),
            rule_range: data.rule_range
          };
          this.formValidate = datas;
          console.log('getCaijiRule', json);
        });
    }
  }
};
</script>
